(function($){
    $(document).ready(function() {
        function onResize() {
            var wWidth = $(window).width();
            var oneNewsWidth = $('.latest-news-wrapper li').width();
            var containerWidth = $('.container').width();
            if(wWidth > 1024) {
                $('.home-page .blocks-frame').width(oneNewsWidth + ((wWidth - containerWidth) / 2));
                $('.video-frame').width(wWidth - (oneNewsWidth + (wWidth - containerWidth) / 2));
            }
        };

        var HomeVideosPopup = function(overlay,closeButton) {
            self = this;
            this.overlay = overlay;
            this.closeButton = closeButton;
            this.$videoPlayer = this.overlay.find('video');
            this.videoPlayerHTML = this.$videoPlayer.get(0);
            this.VideoPlay = $('.VideoPlay');
            this.opened = false;
            this.autoplay = false;
            this.initialised = false;

            this.init = function() {
                // set overlay opacity to 1
                self.overlay.addClass('initialized');

                // close popup when init
                self.close();

                if(!!window.vp2_html5_bottom_settings && window.vp2_html5_bottom_settings.autoPlay) {
                    self.autoplay = true;
                    // stop video when init if autoplay is true in player settings
                    self.$videoPlayer.on('play',function(){
                        setTimeout(function() {
                            self.videoPlayerHTML.pause();
                            self.$videoPlayer.off('play');
                            self.initialised = true;
                        },0);
                    });
                } else {
                    self.initialised = true;
                }

                // define close button event
                self.closeButton.on('click',function() {
                    self.close();
                });
            };

            this.open = function() {
                if(this.initialised) {
                    self.opened = true;
                    self.overlay.addClass('open');

                    self.$videoPlayer.on('play',function(){
                        self.VideoPlay.addClass('VideoPause');
                    });

                    self.$videoPlayer.on('pause',function(){
                        self.VideoPlay.removeClass('VideoPause');
                    });

                    // play video when open popup if autoplay is true
                    if(self.autoplay && self.videoPlayerHTML.paused) {
                        self.videoPlayerHTML.play();
                        self.VideoPlay.addClass('VideoPause');
                    }
                }
            };

            this.close = function() {
                // stop video when close popup
                if(self.opened && !self.videoPlayerHTML.paused) {
                    self.videoPlayerHTML.pause();
                    self.VideoPlay.removeClass('VideoPause');
                }

                self.$videoPlayer.off('play');
                self.$videoPlayer.off('pause');

                self.opened = false;
                self.overlay.removeClass('open');
            };

            this.init();
        };

        var homeVideosPopupOverlay = $('.js-videos-popup');
        var homeVideosPopupCloseButton = $('.js-home-videos-close');

        var homeVideosPopup = new HomeVideosPopup(homeVideosPopupOverlay,homeVideosPopupCloseButton);

        $('.js-open-videos').on('click',function() {
            homeVideosPopup.open();
        });

        onResize();

        $(window).resize(function () {
            onResize();
        });

    });
})(jQuery);